/**
 * HTML 안전 처리 유틸.
 *
 * 사용자 입력이 섞인 문자열은 **항상** 이 유틸을 통과시킨다.
 * 외부 라이브러리(DOMPurify) 없이 브라우저 파서로 화이트리스트 검사만 한다.
 */
const ALLOWED_TAGS = new Set([
  "P",
  "BR",
  "B",
  "I",
  "U",
  "STRONG",
  "EM",
  "A",
  "UL",
  "OL",
  "LI",
  "H1",
  "H2",
  "H3",
  "H4",
  "BLOCKQUOTE",
  "TABLE",
  "THEAD",
  "TBODY",
  "TR",
  "TH",
  "TD",
  "IMG",
  "SPAN",
  "DIV",
])

const ALLOWED_ATTRIBUTES = new Set([
  "href",
  "src",
  "alt",
  "title",
  "width",
  "height",
])

/** 텍스트를 HTML 에 넣기 전 이스케이프한다 (템플릿 문자열 조립용) */
function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

function sanitizeElement(element: Element) {
  Array.from(element.children).forEach((child) => sanitizeElement(child))

  if (!ALLOWED_TAGS.has(element.tagName)) {
    element.replaceWith(...Array.from(element.childNodes))
    return
  }

  Array.from(element.attributes).forEach((attribute) => {
    const name = attribute.name.toLowerCase()
    const isAllowed = ALLOWED_ATTRIBUTES.has(name)
    const isJavascriptUrl = attribute.value
      .replace(/\s/g, "")
      .toLowerCase()
      .startsWith("javascript:")

    if (!isAllowed || isJavascriptUrl) {
      element.removeAttribute(attribute.name)
    }
  })
}

/**
 * 에디터 HTML 을 렌더하기 전 반드시 통과시킨다 (Stored XSS 방지).
 * `dangerouslySetInnerHTML` 에 원본 문자열을 그대로 넣지 않는다.
 */
function sanitizeHtml(html: string): string {
  if (!html) return ""

  const template = document.createElement("template")
  template.innerHTML = html

  Array.from(template.content.children).forEach((child) =>
    sanitizeElement(child),
  )

  return template.innerHTML
}

export { escapeHtml, sanitizeHtml }
